import React from 'react'
import styled from 'styled-components'
import CourseButton from './CourseButton'

export default function FeaturedLesson({ lesson, unit }) {
  return (
    <FeaturedLessonWrapper className="featured-lesson">
      {lesson.image && (
        <div className="lesson-image-wrapper">
          <img src={lesson.image} alt="lesson overview" />
        </div>
      )}
      <div className="lesson-content-wrapper">
        <div className="unit-title">{unit.unit_name}</div>
        <h4 className="lesson-title">{lesson.title}</h4>
        <CourseButton unit={unit} lesson={lesson} />
      </div>
    </FeaturedLessonWrapper>
  )
}

const FeaturedLessonWrapper = styled.div`
  background: var(--dark-backgrorund);
`
